import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import { AlliedProposalFormDelegate } from 'store/modules/initiate-proposal/allied/proposalFormDelegate';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from '../styles';
import { ALLIED_INITIATE_PROPOSAL_FORM_ID } from '../constants';
import DomainProductLines from '../DomainProductLines';

interface Props {
  proposalFormDelegate: AlliedProposalFormDelegate;
}

const AlliedInitiateProposalForm: React.FC<Props> = observer(({ proposalFormDelegate }) => {
  const { proposalForm, effectiveDatesOptions, domainProductLineItems, isAvailableProductLinesLoading } =
    proposalFormDelegate;

  return (
    <IMFormStyled id={ALLIED_INITIATE_PROPOSAL_FORM_ID} formController={proposalForm}>
      <SectionTitle text="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled text="Additional Information" />
      <IMSicSearch label="SIC Code" size="full" />

      <FollowingSectionTitleStyled text="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isAvailableProductLinesLoading} />
    </IMFormStyled>
  );
});

export default AlliedInitiateProposalForm;
